/* Klasyk w Ramce — custom storefront JS (bez Shrine).
   Liczniki liczą wyłącznie do prawdziwych terminów (koniec rabatu w Shopify, godzina graniczna wysyłki). */
(() => {
  'use strict';

  const C = window.KWR || {};
  const R = Object.assign({ cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', collections: '/collections/all' }, C.routes);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Formatowanie cen (shop.money_format) ---------- */
  const num = (v, d, t, s) => {
    const [i, f] = v.toFixed(d).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
  };
  const FORMATS = {
    amount: (v) => num(v, 2, ',', '.'),
    amount_no_decimals: (v) => num(v, 0, ',', '.'),
    amount_with_comma_separator: (v) => num(v, 2, '.', ','),
    amount_no_decimals_with_comma_separator: (v) => num(v, 0, '.', ','),
    amount_with_space_separator: (v) => num(v, 2, ' ', ','),
    amount_no_decimals_with_space_separator: (v) => num(v, 0, ' ', ','),
    amount_with_period_and_space_separator: (v) => num(v, 2, ' ', '.'),
    amount_with_apostrophe_separator: (v) => num(v, 2, "'", '.'),
  };
  const money = (cents) => {
    const fmt = C.moneyFormat || '{{amount_with_comma_separator}} zł';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (FORMATS[key] || FORMATS.amount)(Number(cents) / 100));
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Promocja: progi ---------- */
  const promo = () => (window.KWR && window.KWR.promo && new Date(window.KWR.promo.end) > new Date() ? window.KWR.promo : null);
  const tierFor = (qty) => {
    const p = promo();
    if (!p) return null;
    return p.tiers.filter((t) => qty >= t.qty).sort((a, b) => b.pct - a.pct)[0] || null;
  };
  const nextTier = (qty) => {
    const p = promo();
    if (!p) return null;
    return p.tiers.filter((t) => qty < t.qty).sort((a, b) => a.qty - b.qty)[0] || null;
  };
  const plural = (n) => (n === 1 ? 'ramkę' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'ramki' : 'ramek');

  /* ---------- Liczniki (prawdziwe terminy) ---------- */
  const two = (n) => String(n).padStart(2, '0');
  function formatLeft(ms, style) {
    const s = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    if (style === 'short') return h + d * 24 > 0 ? `${h + d * 24} h ${m} min` : `${m} min`;
    return d > 0 ? `${d} d ${two(h)}:${two(m)}:${two(sec)}` : `${two(h)}:${two(m)}:${two(sec)}`;
  }
  function tickCountdowns() {
    const now = Date.now();
    $$('[data-k-countdown]').forEach((el) => {
      const end = Date.parse(el.dataset.kCountdown);
      if (Number.isNaN(end)) return;
      if (end <= now) {
        const box = el.closest('[data-k-expire]');
        if (box) box.hidden = true;
        return;
      }
      el.textContent = formatLeft(end - now, el.dataset.kCountdownStyle);
    });
  }

  /* ---------- Wysyłka: dni robocze, godzina graniczna, święta ---------- */
  const DATE_FMT = new Intl.DateTimeFormat('pl-PL', { weekday: 'short', day: '2-digit', month: '2-digit' });
  const fmtDay = (d) => DATE_FMT.format(d).replace(/\.$/, '');
  const ymd = (d) => `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}`;
  function addBusinessDays(from, n, holidays) {
    const d = new Date(from);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6 && !holidays.has(ymd(d))) added++;
    }
    return d;
  }
  const isBusiness = (d, holidays) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays.has(ymd(d));

  function updateShipping() {
    $$('[data-k-ship]').forEach((box) => {
      const holidays = new Set((box.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean));
      const cutoffH = Number(box.dataset.cutoff) || 24;
      const now = new Date();
      // Dzień przyjęcia zamówienia: dziś (jeśli roboczy i przed godziną graniczną), w innym razie następny dzień roboczy.
      let base = new Date(now);
      base.setHours(0, 0, 0, 0);
      const cutoff = new Date(base);
      cutoff.setHours(cutoffH, 0, 0, 0);
      if (!isBusiness(base, holidays) || now >= cutoff) {
        do { base.setDate(base.getDate() + 1); } while (!isBusiness(base, holidays));
      }
      const deadline = new Date(base);
      deadline.setHours(cutoffH, 0, 0, 0);
      const shipBy = addBusinessDays(base, Number(box.dataset.max) || 2, holidays);
      const etaFrom = addBusinessDays(base, (Number(box.dataset.min) || 1) + (Number(box.dataset.tmin) || 1), holidays);
      const etaTo = addBusinessDays(base, (Number(box.dataset.max) || 2) + (Number(box.dataset.tmax) || 2), holidays);
      $('[data-k-ship-left]', box).textContent = formatLeft(deadline - now, 'short');
      $('[data-k-ship-by]', box).textContent = fmtDay(shipBy);
      $('[data-k-ship-eta]', box).textContent = `${fmtDay(etaFrom)} – ${fmtDay(etaTo)}`;
    });
  }

  const tick = () => { tickCountdowns(); updateShipping(); };
  tick();
  setInterval(tick, 1000);

  /* ---------- Pasek komunikatów ---------- */
  $$('[data-k-strip]').forEach((strip) => {
    const msgs = $$('.k-strip__msg', strip);
    if (msgs.length < 2 || reduceMotion) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
    }, 3800);
  });

  /* ---------- Cart API ---------- */
  async function api(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Nie udało się zaktualizować koszyka. Odśwież stronę i spróbuj ponownie.');
    return data;
  }
  const getCart = () => api(`${R.cart}.js`);

  function setCount(count) {
    $$('[data-k-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  /* ---------- Szuflada koszyka ---------- */
  const drawer = $('[data-k-drawer]');
  let lastFocus = null;

  function renderPromo(cart) {
    const box = $('[data-k-drawer-promo]', drawer);
    const p = promo();
    if (!p || !cart.item_count) { box.hidden = true; return; }
    const qty = cart.item_count;
    const cur = tierFor(qty);
    const next = nextTier(qty);
    const max = Math.max(...p.tiers.map((t) => t.qty));
    const pct = Math.min(100, (qty / max) * 100);
    const msg = next
      ? `Dodaj jeszcze <strong>${next.qty - qty} ${plural(next.qty - qty)}</strong>, a rabat wzrośnie do <strong>−${next.pct}%</strong>`
      : `Masz najwyższy rabat: <strong>−${cur.pct}%</strong> na całe zamówienie`;
    box.innerHTML = `
      <p class="k-drawer__promo-msg">${msg}</p>
      <div class="k-meter" role="progressbar" aria-valuemin="0" aria-valuemax="${max}" aria-valuenow="${Math.min(qty, max)}" aria-label="Postęp do rabatu">
        <span style="width:${pct}%"></span>
        ${p.tiers.map((t) => `<i style="left:${(t.qty / max) * 100}%" class="${qty >= t.qty ? 'is-hit' : ''}">−${t.pct}%</i>`).join('')}
      </div>
      <p class="k-drawer__promo-time">${esc(p.title)} kończy się za <strong data-k-countdown="${esc(p.end)}" data-k-countdown-style="long">—</strong></p>`;
    box.hidden = false;
  }

  function renderUpsell(cart) {
    const box = $('[data-k-drawer-upsell]', drawer);
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const list = (window.KWR.upsell || []).filter((u) => !inCart.has(u.product_id)).slice(0, 3);
    if (!cart.item_count || !list.length) { box.hidden = true; return; }
    const next = nextTier(cart.item_count);
    box.innerHTML = `
      <p class="k-upsell__head">Dodaj do kolekcji${next ? ` <span>i zgarnij −${next.pct}%</span>` : ''}</p>
      <ul class="k-upsell__list">${list.map((u) => `
        <li class="k-upsell__item">
          <a href="${esc(u.url)}" class="k-upsell__img">${u.image ? `<img src="${esc(u.image)}" alt="" width="56" height="75" loading="lazy">` : ''}</a>
          <div class="k-upsell__text"><a href="${esc(u.url)}">${esc(u.title)}</a><span>${money(u.price)}</span></div>
          <button type="button" class="k-upsell__add" data-k-upsell-add="${u.variant_id}" aria-label="Dodaj do koszyka: ${esc(u.title)}">+ Dodaj</button>
        </li>`).join('')}
      </ul>`;
    box.hidden = false;
  }

  function renderCart(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    const items = $('[data-k-drawer-items]', drawer);
    const foot = $('[data-k-drawer-foot]', drawer);
    $('[data-k-drawer-count]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    renderPromo(cart);
    renderUpsell(cart);

    if (!cart.item_count) {
      items.innerHTML = `<div class="k-drawer__empty"><p>Koszyk jest pusty.</p><a class="k-btn k-btn--ghost" href="${esc(R.collections)}">Zobacz wszystkie ramki</a></div>`;
      foot.hidden = true;
      tickCountdowns();
      return;
    }

    items.innerHTML = `<ul class="k-lines">${cart.items
      .map((it, i) => {
        const img = it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=160` : '';
        const props = Object.entries(it.properties || {})
          .filter(([k, v]) => v && !k.startsWith('_'))
          .map(([k, v]) => `<span>${esc(k)}: ${esc(v)}</span>`)
          .join('');
        const variant = it.variant_title && !/Default Title/i.test(it.variant_title) ? `<span>${esc(it.variant_title)}</span>` : '';
        const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
        return `<li class="k-line">
          <a class="k-line__img" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="" width="80" height="106" loading="lazy">` : ''}</a>
          <div class="k-line__info">
            <a class="k-line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            <p class="k-line__meta">${variant}${props}</p>
            <div class="k-line__row">
              <div class="k-qty k-qty--sm">
                <button type="button" data-k-line="${i + 1}" data-k-line-qty="${it.quantity - 1}" aria-label="Zmniejsz ilość: ${esc(it.product_title)}">−</button>
                <span aria-live="polite">${it.quantity}</span>
                <button type="button" data-k-line="${i + 1}" data-k-line-qty="${it.quantity + 1}" aria-label="Zwiększ ilość: ${esc(it.product_title)}">+</button>
              </div>
              <span class="k-line__price">${was}<strong>${money(it.final_line_price)}</strong></span>
            </div>
            <button type="button" class="k-line__remove" data-k-line="${i + 1}" data-k-line-qty="0">Usuń</button>
          </div>
        </li>`;
      })
      .join('')}</ul>`;

    const saved = cart.total_discount || 0;
    $('[data-k-drawer-savings-row]', drawer).hidden = !saved;
    $('[data-k-drawer-savings]', drawer).textContent = saved ? `−${money(saved)}` : '';
    $('[data-k-drawer-total]', drawer).textContent = money(cart.total_price);
    $('[data-k-drawer-ship]', drawer).textContent = window.KWR.shipNote ? `Dostawa: ${window.KWR.shipNote} – wybierzesz w kasie.` : 'Koszt dostawy dodasz w kasie.';
    foot.hidden = false;
    tickCountdowns();
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('k-lock');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    $('.k-drawer__x', drawer).focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('k-lock');
    const done = () => { drawer.hidden = true; };
    if (reduceMotion) done(); else setTimeout(done, 280);
    if (lastFocus) lastFocus.focus();
  }

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-k-drawer-close]')) { closeDrawer(); return; }
      const add = e.target.closest('[data-k-upsell-add]');
      const line = e.target.closest('[data-k-line]');
      const btn = add || line;
      if (!btn) return;
      btn.disabled = true;
      try {
        if (add) await api(`${R.cartAdd}.js`, { items: [{ id: Number(add.dataset.kUpsellAdd), quantity: 1 }] });
        else await api(`${R.cartChange}.js`, { line: Number(line.dataset.kLine), quantity: Math.max(0, Number(line.dataset.kLineQty)) });
        renderCart(await getCart());
      } catch (err) {
        btn.disabled = false;
        alert(err.message);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (drawer.hidden) return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        const f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', drawer).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    $$('[data-k-cart-open]').forEach((a) =>
      a.addEventListener('click', async (e) => {
        e.preventDefault();
        openDrawer();
        try { renderCart(await getCart()); } catch (err) { window.location.href = a.href; }
      })
    );
  }

  /* ---------- Formularz produktu ---------- */
  $$('[data-k-product-section]').forEach((section) => {
    const form = $('[data-k-form]', section);
    if (!form) return;
    const jsonEl = $('[data-k-product-json]', section);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const idInput = $('[data-k-variant-id]', form);
    const atc = $('[data-k-atc]', form);
    const atcLabel = $('[data-k-atc-label]', form);
    const atcText = atcLabel ? atcLabel.textContent.trim() : '';
    const errorEl = $('[data-k-error]', form);
    const qtyInput = $('[data-k-qty-input]', form);
    const sumEl = $('[data-k-sum]', form);
    const bundleInputs = $$('[data-k-bundle-item]', form);
    let unitPrice = product ? (product.variants.find((x) => String(x.id) === idInput.value) || product.variants[0]).price : 0;

    // Podsumowanie zestawu + podświetlenie progu promocji
    function updateSummary() {
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      const chosen = bundleInputs.filter((i) => i.checked);
      const count = qty + chosen.length;
      const gross = unitPrice * qty + chosen.reduce((s, i) => s + Number(i.dataset.price), 0);
      const tier = tierFor(count);
      $$('[data-k-tier]', section).forEach((li) => {
        const t = Number(li.dataset.kTier);
        const active = tier ? t === tier.qty : t === 1;
        li.classList.toggle('is-active', active);
      });
      if (count > 1) {
        const net = tier ? gross - Math.floor((gross * tier.pct) / 100) : gross; // Shopify zaokrągla rabat w dół
        sumEl.innerHTML = tier
          ? `${count} ${plural(count)} · <strong>${money(net)}</strong> z rabatem −${tier.pct}% (oszczędzasz ${money(gross - net)})`
          : `${count} ${plural(count)} · <strong>${money(gross)}</strong>`;
        sumEl.hidden = false;
      } else {
        sumEl.hidden = true;
      }
      if (atcLabel && !atc.disabled) atcLabel.textContent = chosen.length ? `${atcText} (${count})` : atcText;
    }
    bundleInputs.forEach((i) => i.addEventListener('change', updateSummary));

    // Ilość
    $$('[data-k-qty]', form).forEach((b) =>
      b.addEventListener('click', () => {
        qtyInput.value = Math.min(20, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.kQty)));
        updateSummary();
      })
    );
    qtyInput.addEventListener('change', updateSummary);

    // Warianty
    if (product && $$('[data-k-option]', form).length) {
      form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-k-option]')) return;
        const chosen = product.options.map((_, i) => {
          const checked = $(`[data-k-option="${i}"]:checked`, form);
          return checked ? checked.value : null;
        });
        const variant = product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        const ok = variant && variant.available;
        if (variant) {
          idInput.value = variant.id;
          unitPrice = variant.price;
          $$('[data-k-price], [data-k-price-sticky]', section).forEach((el) => { el.textContent = money(variant.price); });
          const cmp = $('[data-k-compare]', section);
          if (cmp) cmp.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        }
        atc.disabled = !ok;
        atcLabel.textContent = ok ? atcText : variant ? 'Wyprzedane' : 'Niedostępne';
        updateSummary();
      });
    }

    // Dodanie do koszyka (produkt główny + wybrane z „Dobierz do kolekcji”)
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atc.disabled) return;
      errorEl.hidden = true;
      const fd = new FormData(form);
      const properties = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim()) properties[m[1]] = String(v).trim();
      }
      const items = [{ id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1), properties }];
      bundleInputs.filter((i) => i.checked).forEach((i) => items.push({ id: Number(i.value), quantity: 1 }));
      atc.disabled = true;
      atc.classList.add('is-loading');
      try {
        await api(`${R.cartAdd}.js`, { items });
        bundleInputs.forEach((i) => { i.checked = false; });
        updateSummary();
        const cart = await getCart();
        if (drawer) { renderCart(cart); openDrawer(); } else { window.location.href = R.cart; }
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        atc.disabled = false;
        atc.classList.remove('is-loading');
      }
    });

    // Przyklejony pasek (pokazuje się, gdy główny przycisk zniknie u góry ekranu)
    const bar = $('[data-k-sticky]', section);
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        const b = $('[data-k-sticky-atc]', bar);
        if (b) b.tabIndex = on ? 0 : -1;
      }).observe(atc);
      $('[data-k-sticky-atc]', bar).addEventListener('click', () => form.requestSubmit());
    }

    updateSummary();
  });

  /* ---------- Galeria ---------- */
  $$('[data-k-gallery]').forEach((g) => {
    const track = $('[data-k-track]', g);
    const slides = $$('[data-k-slide]', g);
    const thumbs = $$('[data-k-thumb]', g);
    const count = $('[data-k-count]', g);
    if (slides.length < 2) return;
    const go = (i) => track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    let cur = 0;
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, cur + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, cur - 1)); }
    });
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (!en.isIntersecting) return;
        cur = slides.indexOf(en.target);
        thumbs.forEach((t, j) => t.setAttribute('aria-current', String(cur === j)));
        if (count) count.textContent = `${cur + 1} / ${slides.length}`;
      }),
      { root: track, threshold: 0.6 }
    );
    slides.forEach((s) => io.observe(s));
  });

  /* ---------- Anatomia: punkt ↔ legenda ---------- */
  $$('[data-k-anatomy]').forEach((a) => {
    const set = (n) => {
      $$('[data-k-pin]', a).forEach((p) => p.classList.toggle('is-active', p.dataset.kPin === n));
      $$('[data-k-leg]', a).forEach((l) => l.classList.toggle('is-active', l.dataset.kLeg === n));
    };
    $$('[data-k-pin]', a).forEach((p) => {
      p.addEventListener('mouseenter', () => set(p.dataset.kPin));
      p.addEventListener('focus', () => set(p.dataset.kPin));
      p.addEventListener('click', () => {
        set(p.dataset.kPin);
        const leg = $(`[data-k-leg="${p.dataset.kPin}"]`, a);
        if (leg && window.matchMedia('(max-width: 989px)').matches) leg.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    $$('[data-k-leg]', a).forEach((l) => l.addEventListener('mouseenter', () => set(l.dataset.kLeg)));
    a.addEventListener('mouseleave', () => set(null));
  });

  /* ---------- Tabliczka: przechył + błysk ---------- */
  $$('[data-k-tilt]').forEach((el) => {
    if (reduceMotion) return;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', `${(-y * 7).toFixed(2)}deg`);
        el.style.setProperty('--ry', `${(x * 9).toFixed(2)}deg`);
        el.style.setProperty('--sheen', `${(x * 100 + 50).toFixed(1)}%`);
      });
      el.addEventListener('pointerleave', () => {
        el.style.removeProperty('--rx');
        el.style.removeProperty('--ry');
        el.style.removeProperty('--sheen');
      });
    } else if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        if (en.isIntersecting) { el.classList.add('is-lit'); io.disconnect(); }
      }, { threshold: 0.6 });
      io.observe(el);
    }
  });
})();

/* ---------- Język planszy (PDP) + katalog z filtrami ---------- */
(() => {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Język planszy: przełącznik PL/EN na tabliczce ↔ wybór w formularzu zakupu
  const setLang = (l) => {
    $$('[data-k-langscope]').forEach((s) => { s.dataset.lang = l; });
    $$('[data-k-lang-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.kLangSet === l)));
    $$('[data-k-lang-radio]').forEach((r) => { r.checked = r.dataset.kLangRadio === l; });
  };
  $$('[data-k-lang-set]').forEach((b) => b.addEventListener('click', () => setLang(b.dataset.kLangSet)));
  $$('[data-k-lang-radio]').forEach((r) => r.addEventListener('change', () => { if (r.checked) setLang(r.dataset.kLangRadio); }));

  // Katalog: kategoria, marka, szukaj, sortuj (wszystko po stronie przeglądarki)
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l');
  const plural = (n) => (n === 1 ? 'model' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'modele' : 'modeli');
  $$('[data-k-catalog]').forEach((cat) => {
    const grid = cat.querySelector('[data-k-grid]');
    const cells = $$('[data-k-cell]', grid);
    const cta = cat.querySelector('[data-k-cta-cell]');
    const chips = $$('[data-k-filter-cat]', cat);
    const q = cat.querySelector('[data-k-search]');
    const brand = cat.querySelector('[data-k-brand]');
    const sort = cat.querySelector('[data-k-sort]');
    const count = cat.querySelector('[data-k-count-label]');
    const empty = cat.querySelector('[data-k-empty]');
    let activeCat = '';

    function apply() {
      const term = norm(q.value.trim());
      const b = brand.value;
      let shown = 0;
      cells.forEach((li) => {
        const a = li.querySelector('[data-k-item]');
        const ok = (!activeCat || a.dataset.cat === activeCat) && (!b || a.dataset.brand === b) && (!term || norm(a.dataset.name).includes(term));
        li.hidden = !ok;
        if (ok) shown += 1;
      });
      const key = sort.value;
      const sorted = [...cells].sort((x, y) => {
        const ax = x.querySelector('[data-k-item]');
        const ay = y.querySelector('[data-k-item]');
        if (key === 'price-asc') return ax.dataset.price - ay.dataset.price;
        if (key === 'price-desc') return ay.dataset.price - ax.dataset.price;
        if (key === 'name') return ax.dataset.name.localeCompare(ay.dataset.name, 'pl');
        return x.dataset.order - y.dataset.order;
      });
      sorted.forEach((li) => grid.appendChild(li));
      const plain = !activeCat && !b && !term && !key;
      if (cta) {
        cta.hidden = !plain;
        if (plain) grid.insertBefore(cta, sorted[Number(cta.dataset.pos) || 7] || null);
      }
      empty.hidden = shown > 0;
      count.textContent = `${shown} ${plural(shown)}`;
      const u = new URL(window.location.href);
      if (activeCat) u.searchParams.set('kategoria', activeCat); else u.searchParams.delete('kategoria');
      window.history.replaceState(null, '', u);
    }

    chips.forEach((c) => c.addEventListener('click', () => {
      activeCat = c.dataset.kFilterCat;
      chips.forEach((x) => { x.classList.toggle('is-on', x === c); x.setAttribute('aria-pressed', String(x === c)); });
      apply();
    }));
    q.addEventListener('input', apply);
    brand.addEventListener('change', apply);
    sort.addEventListener('change', apply);

    const pre = new URLSearchParams(window.location.search).get('kategoria');
    const chip = pre && chips.find((c) => c.dataset.kFilterCat === pre);
    if (chip) chip.click();
  });
})();
